import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOADSUBSCRIPTIONS = 'react/common/subscriptions/LOADSUBSCRIPTIONS',
    LOADSUBSCRIPTIONS_PENDING = 'react/common/subscriptions/LOADSUBSCRIPTIONS_PENDING',
    LOADSUBSCRIPTIONS_FULFILLED = 'react/common/subscriptions/LOADSUBSCRIPTIONS_FULFILLED',
    LOADSUBSCRIPTIONS_REJECTED = 'react/common/subscriptions/LOADSUBSCRIPTIONS_REJECTED',

    LOADSUBSCRIPTION = 'react/common/subscriptions/LOADSUBSCRIPTION',
    LOADSUBSCRIPTION_PENDING = 'react/common/subscriptions/LOADSUBSCRIPTION_PENDING',
    LOADSUBSCRIPTION_FULFILLED = 'react/common/subscriptions/LOADSUBSCRIPTION_FULFILLED',
    LOADSUBSCRIPTION_REJECTED = 'react/common/subscriptions/LOADSUBSCRIPTION_REJECTED',

    SAVESUBSCRIPTION = 'react/common/subscriptions/SAVESUBSCRIPTION',
    SAVESUBSCRIPTION_PENDING = 'react/common/subscriptions/SAVESUBSCRIPTION_PENDING',
    SAVESUBSCRIPTION_FULFILLED = 'react/common/subscriptions/SAVESUBSCRIPTION_FULFILLED',
    SAVESUBSCRIPTION_REJECTED = 'react/common/subscriptions/SAVESUBSCRIPTION_REJECTED',

    ADDSUBSCRIPTION = 'react/common/subscriptions/ADDSUBSCRIPTION',
    ADDSUBSCRIPTION_PENDING = 'react/common/subscriptions/ADDSUBSCRIPTION_PENDING',
    ADDSUBSCRIPTION_FULFILLED = 'react/common/subscriptions/ADDSUBSCRIPTION_FULFILLED',
    ADDSUBSCRIPTION_REJECTED = 'react/common/subscriptions/ADDSUBSCRIPTION_REJECTED',

    // NEWSUBSCRIPTION
    NEWSUBSCRIPTION = 'react/common/subscriptions/NEWSUBSCRIPTION',

    // CONTACT SUBSCRIPTION
    LOADCONTACTPURCHASED = 'react/common/contact/LOADCONTACTPURCHASED',
    LOADCONTACTPURCHASED_PENDING = 'react/common/contact/LOADCONTACTPURCHASED_PENDING',
    LOADCONTACTPURCHASED_FULFILLED = 'react/common/contact/LOADCONTACTPURCHASED_FULFILLED',
    LOADCONTACTPURCHASED_REJECTED = 'react/common/contact/LOADCONTACTPURCHASED_REJECTED',

    SAVECONTACTSUBSCRIPTION = 'react/common/contact/SAVECONTACTSUBSCRIPTION',
    SAVECONTACTSUBSCRIPTION_PENDING = 'react/common/contact/SAVECONTACTSUBSCRIPTION_PENDING',
    SAVECONTACTSUBSCRIPTION_FULFILLED = 'react/common/contact/SAVECONTACTSUBSCRIPTION_FULFILLED',
    SAVECONTACTSUBSCRIPTION_REJECTED = 'react/common/contact/SAVECONTACTSUBSCRIPTION_REJECTED',

    REMOVEACCESSCONTACTSUBSCRIPTION = 'react/common/contact/REMOVEACCESSCONTACTSUBSCRIPTION',
    REMOVEACCESSCONTACTSUBSCRIPTION_PENDING = 'react/common/contact/REMOVEACCESSCONTACTSUBSCRIPTION_PENDING',
    REMOVEACCESSCONTACTSUBSCRIPTION_FULFILLED = 'react/common/contact/REMOVEACCESSCONTACTSUBSCRIPTION_FULFILLED',
    REMOVEACCESSCONTACTSUBSCRIPTION_REJECTED = 'react/common/contact/REMOVEACCESSCONTACTSUBSCRIPTION_REJECTED',

    DELETECONTACTSUBSCRIPTION = 'react/common/contact/DELETECONTACTSUBSCRIPTION',
    DELETECONTACTSUBSCRIPTION_PENDING = 'react/common/contact/DELETECONTACTSUBSCRIPTION_PENDING',
    DELETECONTACTSUBSCRIPTION_FULFILLED = 'react/common/contact/DELETECONTACTSUBSCRIPTION_FULFILLED',
    DELETECONTACTSUBSCRIPTION_REJECTED = 'react/common/contact/DELETECONTACTSUBSCRIPTION_REJECTED',

    ADDCONTACTSUBSCRIPTION = 'react/common/contact/ADDCONTACTSUBSCRIPTION',
    ADDCONTACTSUBSCRIPTION_PENDING = 'react/common/contact/ADDCONTACTSUBSCRIPTION_PENDING',
    ADDCONTACTSUBSCRIPTION_FULFILLED = 'react/common/contact/ADDCONTACTSUBSCRIPTION_FULFILLED',
    ADDCONTACTSUBSCRIPTION_REJECTED = 'react/common/contact/ADDCONTACTSUBSCRIPTION_REJECTED',

    // CONTACT MEDICAL EXAMINATIONS
    DELETECONTACTMEDICAL = 'react/common/contact/DELETECONTACTMEDICAL',
    DELETECONTACTMEDICAL_PENDING = 'react/common/contact/DELETECONTACTMEDICAL_PENDING',
    DELETECONTACTMEDICAL_FULFILLED = 'react/common/contact/DELETECONTACTMEDICAL_FULFILLED',
    DELETECONTACTMEDICAL_REJECTED = 'react/common/contact/DELETECONTACTMEDICAL_REJECTED',

    SAVECONTACTMEDICAL = 'react/common/contact/SAVECONTACTMEDICAL',
    SAVECONTACTMEDICAL_PENDING = 'react/common/contact/SAVECONTACTMEDICAL_PENDING',
    SAVECONTACTMEDICAL_FULFILLED = 'react/common/contact/SAVECONTACTMEDICAL_FULFILLED',
    SAVECONTACTMEDICAL_REJECTED = 'react/common/contact/SAVECONTACTMEDICAL_REJECTED',

    ADDCONTACTMEDICAL = 'react/common/contact/ADDCONTACTMEDICAL',
    ADDCONTACTMEDICAL_PENDING = 'react/common/contact/ADDCONTACTMEDICAL_PENDING',
    ADDCONTACTMEDICAL_FULFILLED = 'react/common/contact/ADDCONTACTMEDICAL_FULFILLED',
    ADDCONTACTMEDICAL_REJECTED = 'react/common/contact/ADDCONTACTMEDICAL_REJECTED',

    // CONTACT INSURANCE
    DELETECONTACTINSURANCE = 'react/common/contact/DELETECONTACTSUBSCRIPTIONS',
    DELETECONTACTINSURANCE_PENDING = 'react/common/contact/DELETECONTACTSUBSCRIPTIONS_PENDING',
    DELETECONTACTINSURANCE_FULFILLED = 'react/common/contact/DELETECONTACTSUBSCRIPTIONS_FULFILLED',
    DELETECONTACTINSURANCE_REJECTED = 'react/common/contact/DELETECONTACTSUBSCRIPTIONS_REJECTED',

    SAVECONTACTINSURANCE = 'react/common/contact/SAVECONTACTINSURANCE',
    SAVECONTACTINSURANCE_PENDING = 'react/common/contact/SAVECONTACTINSURANCE_PENDING',
    SAVECONTACTINSURANCE_FULFILLED = 'react/common/contact/SAVECONTACTINSURANCE_FULFILLED',
    SAVECONTACTINSURANCE_REJECTED = 'react/common/contact/SAVECONTACTINSURANCE_REJECTED',

    ADDCONTACTINSURANCE = 'react/common/contact/ADDCONTACTINSURANCE',
    ADDCONTACTINSURANCE_PENDING = 'react/common/contact/ADDCONTACTINSURANCE_PENDING',
    ADDCONTACTINSURANCE_FULFILLED = 'react/common/contact/ADDCONTACTINSURANCE_FULFILLED',
    ADDCONTACTINSURANCE_REJECTED = 'react/common/contact/ADDCONTACTINSURANCE_REJECTED',

    CLEARPURCHASED = 'react/common/contact/CLEARPURCHASED',
    OTHER_ACTION = 'react/common/subscriptions/__any_other_action__',
}

export type Types = IBaseAction<Keys>;